module.exports = __webpack_public_path__ + "img/39.e96cd54c.jpg";